module.exports = __webpack_public_path__ + "img/logo-myclinic-2.1a75ba32.png";